export default __webpack_public_path__ + "static/media/M.abeb21c5.svg";